module.exports = {
  get: function () {
    var svgcontent = $('#svgcontent').html();
    var tool = INKIVE.Tool.getInstance();

    return {
      'project_id': INKIVE.C.BOOK.id,
      'svg_save_string': tool.getSaveString(),
      'is_ready_to_save': tool.isReadyToSave(),
      'dom_svgcontent': svgcontent ? true : false,
      'design_id': INKIVE.Tool._current_design_id,
      'page_number': INKIVE.Tool._current_page_number,
      'image_cache': INKIVE.ImagesFactory.imagesData,
      'images_inlined': INKIVE.ImagesFactory.inlinedImages,
      'svg_string': svgcontent || tool.editor.getSvgString()
    };
  }
};
